<script>
// eslint-disable-next-line import/no-unresolved
import ServiceLocation from "../../../../components/Services/ServiceLocation";

export default {
    // eslint-disable-next-line vue/multi-word-component-names
    name: "Location",
    components: {
        ServiceLocation,
    },
    data() {
        return {
            defaultData: {},

            showLocationForm: false,
            showMobileForm: false,
            advancedForm: false,
            showSecondPart: false,

            venueData: {
                venueName: "",
                address1: "",
                address2: "",
                area: "",
                city: "",
                postcode: "",
                lat: "",
                lng: "",
                autocomplete: {},
                country: "United Kingdom",
            },

            settings: {},

            venueMobile: {
                venueName: "",
                address1: "",
                address2: "",
                area: "",
                city: "",
                postcode: "",
                lat: "",
                lng: "",
                autocomplete: {},
                travelDistance: "4 miles",
                country: "United Kingdom",
            },
        };
    },
    methods: {
        prevStep() {
            const { serviceLocation } = this.$refs;
            if (serviceLocation.enterManually) {
                serviceLocation.enterManually = false;
                serviceLocation.editFirstVenue = false;
            } else {
                this.$router.push({ name: "Service ages" });
            }
        },

        nextStep() {
            const { serviceLocation } = this.$refs;
            // If selected both checkboxes and Edit location is clicked
            if (serviceLocation.editFirstVenue && serviceLocation.validateLocation()) {
                serviceLocation.store();
                this.$router.push({ name: "Service availability" });
                return;
            }
            if (
                serviceLocation.hasLocation
                && serviceLocation.isMobile
                && serviceLocation.validateLocation()
                && serviceLocation.validateMobile()
                && serviceLocation.showSecondPart
                && !serviceLocation.editFirstVenue
            ) {
                serviceLocation.store();
                this.$router.push({ name: "Service availability" });
                return;
            }

            // If both checkbox selected
            if (serviceLocation.advancedForm) {
                if (!serviceLocation.enterManually && !serviceLocation.showSecondPart) {
                    serviceLocation.switchManualAddress();
                } else if (serviceLocation.showLocationForm && serviceLocation.validateLocation()) {
                    serviceLocation.showSecondPartForm();
                    return;
                } else if (serviceLocation.editFirstVenue) {
                    serviceLocation.value.editFirstVenue = false;
                    serviceLocation.value.enterManually = false;
                    return;
                }
            }

            if (
                serviceLocation.hasLocation
                && !serviceLocation.isMobile
                && serviceLocation.validateLocation()
            ) {
                serviceLocation.mobileServiceSameVenue = "no";
                serviceLocation.store();
                this.$router.push({ name: "Service availability" });
                return;
            } if (
                !serviceLocation.hasLocation
                && serviceLocation.isMobile
                && serviceLocation.validateMobile()
            ) {
                serviceLocation.mobileServiceSameVenue = "no";
                serviceLocation.store();
                this.$router.push({ name: "Service availability" });
                return;
            } if (
                !serviceLocation.isMobile
                && serviceLocation.venueData.autocomplete !== undefined
            ) {
                serviceLocation.switchManualAddress();
                return;
            }

            if (
                serviceLocation.hasLocation
                && !serviceLocation.isMobile
                && !serviceLocation.validateLocation()
                && serviceLocation.enterManually === false
            ) {
                serviceLocation.mobileServiceSameVenue = "no";
                serviceLocation.store();
                serviceLocation.switchManualAddress();
                return;
            }

            if (!serviceLocation.validateLocation()) {
                serviceLocation.showErrors();
            }
        },

        storeData({ venueData, venueMobile, settings }) {
            this.venueData = venueData;
            this.settings = { ...settings, showSecondPart: false };
            this.venueMobile = venueMobile;

            this.$storage.setStorageSync("venueData", venueData);
            this.$storage.setStorageSync("settings", this.settings);
            this.$storage.setStorageSync("venueMobile", venueMobile);
        },
    },
    watch: {},
    computed: {
        getAutocompleteStatus() {
            if (this.settings.hasLocation && !this.settings.isMobile) {
                return this.venueData.autocomplete === "";
            }

            if (this.settings.isMobile && !this.settings.hasLocation) {
                return this.venueMobile.autocomplete === "";
            }

            return false;
        },

        getSubmitButtonText() {
            if (this.settings.enterManually || (this.settings.isMobile && !this.settings.hasLocation)) {
                return "Next";
            }
            return "Review";
        },
    },
    mounted() {
        const defaultVenueData = {
            venueName: "",
            address1: "",
            address2: "",
            area: "",
            city: "",
            postcode: "",
            lat: "",
            lng: "",
            country: "United Kingdom",
        };

        const defaultVenueDataMobile = {
            venueName: "",
            address1: "",
            address2: "",
            area: "",
            city: "",
            postcode: "",
            lat: "",
            lng: "",
            travelDistance: "4 miles",
            country: "United Kingdom",
        };

        this.venueData = this.$storage.getStorageSync("venueData") || defaultVenueData;

        this.venueMobile = this.$storage.getStorageSync("venueMobile") || defaultVenueDataMobile;

        this.settings = this.$storage.getStorageSync("settings") || {};

        this.defaultData = {
            venueData: this.venueData,
            venueMobile: this.venueMobile,
            settings: this.settings,
        };
    },
};
</script>

<template>
    <div class="location-service mx-auto">
        <div class="mt-4 mb-5 service-steps">
            Step 3 of 5
        </div>

        <h2 class="mb-5">
            Location
        </h2>

        <ServiceLocation
            ref="serviceLocation"
            :default="defaultData"
            @update="storeData"
        />

        <div class="mt-5 d-flex flex-row">
            <button @click="prevStep" class="ml-0 px-3 py-2 d-block btn-new btn-new-outline font-weight-bold">
                Back
            </button>
            <button @click="nextStep" type="submit" class="ml-auto px-4 py-3 d-block btn-new font-weight-bold"
                    :class="{'disabled': getAutocompleteStatus}">{{ getSubmitButtonText }}
            </button>
        </div>
    </div>
</template>

<style scoped>
h2 {
    font-weight: 600;
}
</style>
